// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__CPjIg","inlineSelect":"Select_inlineSelect__3-Cjj"};